import React from "react";
import { connect } from "react-redux";
import { Modal, Form, Checkbox, Spin, Table, Tabs, message,
	TreeSelect,
	Input,
	InputNumber } from 'antd';

import LayoutWrapper from '../../layouts/LayoutWrapper';
import DynamicForm from "../../components/frame/DynamicForm";
import DynamicTable from "../../components/frame/DynamicTable";
import DynamicButton from "../../components/frame/DynamicButton";
import ReactAbstract from "../../components/abstract/React.abstract";
import roleManagementService from "../../services/SystemSetting/role-management-service";
import { fetchDepartmentsList } from '../../actions/department-structure-actions';
const webConfig = require ('../../config.json');
const { TreeNode } = TreeSelect;

class RoleControl extends ReactAbstract {

	childModuleName = "roleManagement"

	state = {
		currentModalStatus: false,
		currentIndex: null,
		currentData: {},
		currentDataStatus: "unload",
		filters: {},
		data: [],
		dataStatus: "unload",
		formColumn: []
	}

	actions = {
		selectAction: roleManagementService.fetchRoleList,
		createAction: roleManagementService.createNewRole,
		updateAction: roleManagementService.updateRole,
		deleteAction: roleManagementService.deleteRoles
	}

	headerColumn = [{
			title: "新增",
			icon: "plus-circle-o",
			access: "c_value",
			click: () => this.setState({
				currentModalStatus: true,
				currentDataStatus: "unload",
				currentData: {},
				currentIndex: null,
			}, () => roleManagementService.fetchRoleInit(res => {
				if (200 === res.status) {
					let managementModules = [];
					let employeeModules = [];
					let mobileModules = [];
					res.data.Modules.forEach(module => {
						if ("员工端" === module.name) {
							// module.Children.forEach(child => {
							// 	child.is_all_active = true;
							// 	child.Permissions.forEach(permission => {
							// 		if (!permission.is_active) {
							// 			child.is_all_active = false;
							// 		}
							// 	})
							// })
							employeeModules.push(module)
						}else if ("移动端" === module.name) {
							mobileModules = module.Children
						}else if ("其他" !== module.name) {
							// module.Children.forEach(child => {
							// 	child.is_all_active = true;
							// 	child.Permissions.forEach(permission => {
							// 		if (!permission.is_active) {
							// 			child.is_all_active = false;
							// 		}
							// 	})
							// })
							managementModules.push(module)
						}
					})
					// console.log(managementModules)
					this.setState({
						currentDataStatus: "loaded",
						currentData: {},
						managementModules: managementModules,
						employeeModules: employeeModules,
						mobileModules: mobileModules,
						formColumn: [{
								label: "角色名称",
								key: "name",
								type: "input",
								span: 12
							}, {
								label: "部门",
								key: "department",
								type: "department",
								span: 12
							}, {
								label: "角色等级",
								key: "level",
								type: "select",
								span: 12,
								children: res.data.Levels.map(level => {
									return {
										id: level.Value,
										text: level.Text
									}
								})
							}, {
								label: "职能",
								key: "competency",
								type: "select",
								span: 12,
								children: res.data.Functions.map(fun => {
									return {
										id: fun.Value,
										text: fun.Text
									}
								})
							}
						]
					}, () => console.log(this.state))
				}
			}, err => this.setState({currentDataStatus: "error"})))
		}, {
			title: "删除",
			icon: "plus-circle-o",
			access: "d_value",
			click: this.publicDelete
		}
	]

	tableColumn = [{
			title: '名称',
			dataIndex: 'name',
			key: 'name',
		}, {
			title: '等级',
			dataIndex: 'level',
			key: 'level',
		}, {
			title: '部门',
			dataIndex: 'department',
			key: 'department',
		}, {
			title: '职能',
			dataIndex: 'competency',
			key: 'competency',
		}, {
			title: '操作',
			dataIndex: 'action',
			key: 'action',
			render: (text, record, index) => (
				<DynamicButton column={this.buttonColumn(text, record, index)}
					module={this.childModuleName}
					access={this.props.access} />
			)
		}
	]

	buttonColumn = (text, record, index) => [{
			size: "small",
			type: "default",
			icon: "edit",
			title: "编辑",
			access: "u_value",
			click: () => this.setState({
				currentModalStatus: true,
				currentDataStatus: "unload",
				currentData: {},
				currentIndex: index,
			}, () => roleManagementService.fetchRoleDetail({modelId: record.id}, res => {
				if (200 === res.status) {
					let managementModules = [];
					let employeeModules = [];
					let mobileModules = [];
					res.data.Modules.forEach(module => {
						if ("员工端" === module.name) {
							// module.Children.forEach(child => {
							// 	child.is_all_active = true;
							// 	child.Permissions.forEach(permission => {
							// 		if (!permission.is_active) {
							// 			child.is_all_active = false;
							// 		}
							// 	})
							// })
							employeeModules.push(module)
						}else if ("移动端" === module.name) {
							mobileModules = module.Children
						}else if ("其他" !== module.name) {
							// module.Children.forEach(child => {
							// 	child.is_all_active = true;
							// 	child.Permissions.forEach(permission => {
							// 		if (!permission.is_active) {
							// 			child.is_all_active = false;
							// 		}
							// 	})
							// })
							managementModules.push(module)
						}
					})
					this.setState({
						currentDataStatus: "loaded",
						currentData: {
							...res.data.Role
						},
						managementModules: managementModules,
						employeeModules: employeeModules,
						mobileModules: mobileModules,
						formColumn: [{
								label: "角色名称",
								key: "name",
								type: "input",
								span: 12
							}, {
								label: "部门",
								key: "department",
								type: "department",
								span: 12
							}, {
								label: "角色等级",
								key: "level",
								type: "select",
								span: 12,
								children: res.data.Levels.map(level => {
									return {
										id: level.Value,
										text: level.Text
									}
								})
							}, {
								label: "职能",
								key: "competency",
								type: "select",
								span: 12,
								children: res.data.Functions.map(fun => {
									return {
										id: fun.Value,
										text: fun.Text
									}
								})
							}
						]
					}, () => console.log(this.state))
				}
			}, err => this.setState({currentDataStatus: "error"})))
		}
	]

	roleColumn = [{
			title: '模块名称',
			dataIndex: 'name',
			key: 'name',
		}
	]

	changePermission = (parentIndex, index, childIndex) => this.setState({
		managementModules: [
			...this.state.managementModules.slice(0, parentIndex),
			{
				...this.state.managementModules[parentIndex],
				Children: [
					...this.state.managementModules[parentIndex].Children.slice(0, index),
					{
						...this.state.managementModules[parentIndex].Children[index],
						Permissions: [
							...this.state.managementModules[parentIndex].Children[index].Permissions.slice(0, childIndex),
							{
								...this.state.managementModules[parentIndex].Children[index].Permissions[childIndex],
								is_active: !this.state.managementModules[parentIndex].Children[index].Permissions[childIndex].is_active
							},
							...this.state.managementModules[parentIndex].Children[index].Permissions.slice(childIndex + 1)
						]
					},
					...this.state.managementModules[parentIndex].Children.slice(index + 1)			
				]
			},
			...this.state.managementModules.slice(parentIndex + 1)
		]
	})

	changeAllPermission = (parentIndex, index) => {
		let copyManagementModules = this.state.managementModules;
		if (copyManagementModules[parentIndex].Children[index].Permissions.filter(item => item.is_active).length === copyManagementModules[parentIndex].Children[index].Permissions.length) {
			copyManagementModules[parentIndex].Children[index].Permissions.forEach(permission => {
				permission.is_active = false;
			})
		}else{
			copyManagementModules[parentIndex].Children[index].Permissions.forEach(permission => {
				permission.is_active = true;
			})
		}
		this.setState({managementModules: copyManagementModules});
	}

	innerColumn = parentIndex => [{
		title: '详情页',
		dataIndex: 'name',
		key: 'name',
		className: "role-inner-1"
	}, {
		title: "全选",
		dataIndex: "id",
		key: "id",
		className: "role-inner-4",
		render: (text, record, index) => <Checkbox key={index} checked={record.Permissions.filter(item => item.is_active).length === record.Permissions.length}
			onChange={this.changeAllPermission.bind(this, parentIndex, index)} />
	}, {
		title: '页签权限',
		dataIndex: 'name_english',
		key: 'name_english',
		className: "role-inner-2",
		render: (text, record, index) => record.Permissions.map((permission, childIndex) => {
			if ("查看" === permission.permission_name) {
				return  <Checkbox key={childIndex} checked={permission.is_active}
					onChange={this.changePermission.bind(this, parentIndex, index, childIndex)} />
			}
			return null;
		})
	}, {
		title: '页签内按钮权限',
		dataIndex: 'description',
		key: 'description',
		className: "role-inner-3",
		render: (text, record, index) => record.Permissions.map((permission, childIndex) => {
			if ("查看" !== permission.permission_name) {
				return  (
					<span key={childIndex}>
						<Checkbox checked={permission.is_active}
							onChange={this.changePermission.bind(this, parentIndex, index, childIndex)} />
						<span style={{padding: "0px 8px 0px 4px"}}>{permission.permission_name}</span>
					</span>
				)
			}
			return null;
		})
	}]

	changeEmployeePermission = (parentIndex, index, childIndex) => this.setState({
		employeeModules: [
			...this.state.employeeModules.slice(0, parentIndex),
			{
				...this.state.employeeModules[parentIndex],
				Children: [
					...this.state.employeeModules[parentIndex].Children.slice(0, index),
					{
						...this.state.employeeModules[parentIndex].Children[index],
						Permissions: [
							...this.state.employeeModules[parentIndex].Children[index].Permissions.slice(0, childIndex),
							{
								...this.state.employeeModules[parentIndex].Children[index].Permissions[childIndex],
								is_active: !this.state.employeeModules[parentIndex].Children[index].Permissions[childIndex].is_active
							},
							...this.state.employeeModules[parentIndex].Children[index].Permissions.slice(childIndex + 1)
						]
					},
					...this.state.employeeModules[parentIndex].Children.slice(index + 1)			
				]
			},
			...this.state.employeeModules.slice(parentIndex + 1)
		]
	})

	changeEmployeeAllPermission = (parentIndex, index) => {
		let copyEmployeeModules = this.state.employeeModules;
		if (copyEmployeeModules[parentIndex].Children[index].Permissions.filter(item => item.is_active).length === copyEmployeeModules[parentIndex].Children[index].Permissions.length) {
			copyEmployeeModules[parentIndex].Children[index].Permissions.forEach(permission => {
				permission.is_active = false;
			})
		}else{
			copyEmployeeModules[parentIndex].Children[index].Permissions.forEach(permission => {
				permission.is_active = true;
			})
		}
		this.setState({employeeModules: copyEmployeeModules});
	}


	innerEmployeeColumn = parentIndex => [{
		title: '详情页',
		dataIndex: 'name',
		key: 'name',
		className: "role-inner-1"
	}, {
		title: "全选",
		dataIndex: "id",
		key: "id",
		className: "role-inner-4",
		render: (text, record, index) => <Checkbox key={index} checked={record.Permissions.filter(item => item.is_active).length === record.Permissions.length}
			onChange={this.changeEmployeeAllPermission.bind(this, parentIndex, index)} />
	}, {
		title: '页签权限',
		dataIndex: 'name_english',
		key: 'name_english',
		className: "role-inner-2",
		render: (text, record, index) => record.Permissions.map((permission, childIndex) => {
			if ("查看" === permission.permission_name) {
				return  <Checkbox key={childIndex} checked={permission.is_active}
					onChange={this.changeEmployeePermission.bind(this, parentIndex, index, childIndex)} />
			}
			return null;
		})
	}, {
		title: '页签内按钮权限',
		dataIndex: 'description',
		key: 'description',
		className: "role-inner-3",
		render: (text, record, index) => record.Permissions.map((permission, childIndex) => {
			if ("查看" !== permission.permission_name) {
				return  (
					<span key={childIndex}>
						<Checkbox checked={permission.is_active}
							onChange={this.changeEmployeePermission.bind(this, parentIndex, index, childIndex)} />
						<span style={{padding: "0px 8px 0px 4px"}}>{permission.permission_name}</span>
					</span>
				)
			}
			return null;
		})
	}]

	changeMobilePermission = (parentIndex, index, childIndex) => this.setState({
		mobileModules: [
			...this.state.mobileModules.slice(0, parentIndex),
			{
				...this.state.mobileModules[parentIndex],
				Children: [
					...this.state.mobileModules[parentIndex].Children.slice(0, index),
					{
						...this.state.mobileModules[parentIndex].Children[index],
						Permissions: [
							...this.state.mobileModules[parentIndex].Children[index].Permissions.slice(0, childIndex),
							{
								...this.state.mobileModules[parentIndex].Children[index].Permissions[childIndex],
								is_active: !this.state.mobileModules[parentIndex].Children[index].Permissions[childIndex].is_active
							},
							...this.state.mobileModules[parentIndex].Children[index].Permissions.slice(childIndex + 1)
						]
					},
					...this.state.mobileModules[parentIndex].Children.slice(index + 1)			
				]
			},
			...this.state.mobileModules.slice(parentIndex + 1)
		]
	})

	changeMobileAllPermission = (parentIndex, index) => {
		let copyMobileModules = this.state.mobileModules;
		if (copyMobileModules[parentIndex].Children[index].Permissions.filter(item => item.is_active).length === copyMobileModules[parentIndex].Children[index].Permissions.length) {
			copyMobileModules[parentIndex].Children[index].Permissions.forEach(permission => {
				permission.is_active = false;
			})
		}else{
			copyMobileModules[parentIndex].Children[index].Permissions.forEach(permission => {
				permission.is_active = true;
			})
		}
		this.setState({mobileModules: copyMobileModules});
	}


	innerMobileColumn = parentIndex => [{
		title: '详情页',
		dataIndex: 'name',
		key: 'name',
		className: "role-inner-1"
	}, {
		title: "全选",
		dataIndex: "id",
		key: "id",
		className: "role-inner-4",
		render: (text, record, index) => <Checkbox key={index} checked={record.Permissions.filter(item => item.is_active).length === record.Permissions.length}
			onChange={this.changeMobileAllPermission.bind(this, parentIndex, index)} />
	}, {
		title: '页签权限',
		dataIndex: 'name_english',
		key: 'name_english',
		className: "role-inner-2",
		render: (text, record, index) => record.Permissions.map((permission, childIndex) => {
			if ("查看" === permission.permission_name) {
				return  <Checkbox key={childIndex} checked={permission.is_active}
					onChange={this.changeMobilePermission.bind(this, parentIndex, index, childIndex)} />
			}
			return null;
		})
	}, {
		title: '页签内按钮权限',
		dataIndex: 'description',
		key: 'description',
		className: "role-inner-3",
		render: (text, record, index) => record.Permissions.map((permission, childIndex) => {
			if ("查看" !== permission.permission_name) {
				return  (
					<span key={childIndex}>
						<Checkbox checked={permission.is_active}
							onChange={this.changeMobilePermission.bind(this, parentIndex, index, childIndex)} />
						<span style={{padding: "0px 8px 0px 4px"}}>{permission.permission_name}</span>
					</span>
				)
			}
			return null;
		})
	}]


	customComponentWillMount() {
		this.props.fetchDepartmentsList();
	}
	setCurrentNode = (action, record, event) => this.setState({
		currentData: {
			...this.state.currentData,
			permissions: {
				...this.state.currentData.permissions,
				[record.name_english]: {
					...this.state.currentData.permissions[record.name_english],
					[action]: event.target.checked,
					module_id: record.id
				}
			}
		}
	})

	publicUpdate = (puts, callback) => {
		if ("function" === typeof this.actions.updateAction) {
			this.actions.updateAction(puts, res => {
				this.publicChange();
				if (res.data.Success) {
					this.toggleCurrentModal();
					message.success("修改数据成功", 4);
					if ("function" === typeof callback) {
						callback(res);
					}else{
						this.setState({
							data: {
								...this.state.data,
								Data: [
									...this.state.data.Data.slice(0, this.state.currentIndex),
									puts,
									...this.state.data.Data.slice(this.state.currentIndex + 1)
								]
							}
						})
					}
				}else{
					message.error("修改数据失败 " + res.data.Errors[0], 4);
				}
			}, err => message.error('修改操作失败, 请联系管理员'));
		}else{
			this.handleError("Child class's actions updateAction is required!");
		}
	}

	publicSubmit = () => this.props.form.validateFields((err, values) => {
		if (!err) {
			let modules = [];
			this.state.employeeModules.forEach(module => {
				module.Children.forEach(child => {
					child.Permissions.forEach(permission => {
						modules.push(permission)
					})
				})
			})
			this.state.managementModules.forEach(module => {
				module.Children.forEach(child => {
					child.Permissions.forEach(permission => {
						modules.push(permission)
					})
				})
			})
			this.state.mobileModules.forEach(module => {
				module.Children.forEach(child => {
					child.Permissions.forEach(permission => {
						modules.push(permission)
					})
				})
			})
			const post = {
				modules: modules,
				...this.state.currentData,
				...values
			}
			const callee = null === this.state.currentIndex ? this.publicCreate : this.publicUpdate;
			callee(post);
		}
	})
	setNameFilter = name => {
		this.setState({ name: name });
		this.publicChange(
			{
				department_id:this.state.department_id,
				name: name
			}
		);
	}
	onSelectTreeChange = (id, value, event) => {
		console.log( event.triggerValue);
		this.setState({
			department_id: event.triggerValue,
		});
		this.publicChange(
			{
				name:this.state.name,
				department_id: event.triggerValue,
			}
		);
	}
	renderTreeNodes = (data) => {
		return data.map((item) => {
			if (item.children) {
				return (
					<TreeNode title={item.name} value={`${item.id}`} key={item.id} dataRef={item}>
						{item.children.length !== 0 && this.renderTreeNodes(item.children)}
					</TreeNode>
				);
			}
			return <TreeNode {...item} />;
		});
	}
	render() {
		return(
			<div className="app-module-item">
				<div className="app-module-header">
					<DynamicButton column={this.headerColumn}
						module={this.childModuleName}
						access={this.props.access} />
							<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
						<Input.Search
							placeholder="名称"
							onSearch={this.setNameFilter}
							style={{ width: 200 }}
							enterButton />
					</div>
					<div className="colAction" style={{ float: "right", margin: "0px 10px 10px 0px" }}>
					{this.props.departmentStructure.departmentsList &&
						<TreeSelect style={{ minWidth: "300px", marginBottom: '15px' }}
							// multiple
							placeholder="请选择部门"
							// showSearch={false}
							autoExpandParent={true}
							dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
							treeDefaultExpandAll
						onChange={this.onSelectTreeChange.bind(this)}>
							{this.renderTreeNodes(this.props.departmentStructure.departmentsList)}
						</TreeSelect>}
					</div>
				</div>
				<Modal width="1200px"
					visible={this.state.currentModalStatus}
					title="角色管理"
					destroyOnClose={true}
					onCancel={this.toggleCurrentModal}
					onOk={this.publicSubmit} >
					{(() => {
					switch (this.state.currentDataStatus) {
						case "reload":
						case "loaded":
							return (
								<div style={{height: "500px", overflow: "auto"}}>
									<DynamicForm column={this.state.formColumn}
										form={this.props.form}
										loadStatus={this.state.currentDataStatus}
										departmentsList={this.props.departmentStructure.departmentsList}
										dataSource={this.state.currentData} />

									<Tabs type="card">
										<Tabs.TabPane tab="员工端" key="1">
											<Table columns={this.roleColumn}
												dataSource={this.state.employeeModules}
												rowKey={record => record.id}
												pagination={false}
												defaultExpandAllRows={true}
												expandedRowRender={(record, parentIndex) =>
												<Table columns={this.innerEmployeeColumn(parentIndex)}
													bordered
													key={record.id}
												  dataSource={record.Children}
												  pagination={false}
												  rowKey={record => record.id} />}/>
										</Tabs.TabPane>
										<Tabs.TabPane tab="管理端" key="2">
											<Table columns={this.roleColumn}
												dataSource={this.state.managementModules}
												rowKey={record => record.id}
												pagination={false}
												defaultExpandAllRows={true}
												expandedRowRender={(record, parentIndex) =>
												<Table columns={this.innerColumn(parentIndex)}
													bordered
													key={record.id}
												  dataSource={record.Children}
												  pagination={false}
												  rowKey={record => record.id} />}/>
										</Tabs.TabPane>
										<Tabs.TabPane tab="移动端" key="3">
											<Table columns={this.roleColumn}
												dataSource={this.state.mobileModules}
												rowKey={record => record.id}
												pagination={false}
												defaultExpandAllRows={true}
												expandedRowRender={(record, parentIndex) =>
												<Table columns={this.innerMobileColumn(parentIndex)}
													bordered
													key={record.id}
												  dataSource={record.Children}
												  pagination={false}
												  rowKey={record => record.id} />}/>
										</Tabs.TabPane>
									</Tabs>
								</div>)
						case "error":
							return (
								<div style={{textAlign:'center', margin: '100px 0px'}}>
									{webConfig.httpFetchErrorInformation}
								</div>);
						case "loading":
						case "unload":
							return (
								<div style={{textAlign:'center', margin: '100px 0px'}}>
									<Spin size="large" />
								</div>);
						default :
							return null;
					}
					})()}
				</Modal>
				<div>
					<DynamicTable column={this.tableColumn}
						dataStatus={this.dataSource().dataStatus}
						dataSource={this.dataSource().data.Data}
						pagination={{
							total: this.dataSource().data.Total,
							pageSize: this.dataSource().data.PageSize,
							current: this.dataSource().filters.page}}
						rowSelection={this.rowSelection}
						setPageFilter={this.publicChange} />
				</div>
			</div>
		)
	}
}


const mapStateToProps = state => {
	return {
		departmentStructure: state.departmentStructure
	}
}

const mapDispatchToProps = {
	fetchDepartmentsList
}

RoleControl = Form.create()(RoleControl);

RoleControl = connect(mapStateToProps, mapDispatchToProps)(RoleControl);

export default LayoutWrapper(RoleControl);




// WEBPACK FOOTER //
// ./src/routes/SystemSetting/RoleControl.js